const colors = {
    'current-color': 'currentColor',
    transparent: 'transparent',

    brandy: '#d5cfc2',
    sand: '#cfbba2',

    white: '#fff',
    'wild-sand': '#f5f5f5',
    silver: '#CCCCCC',
    'dusty-grey': '#666666',
    'gainsboro-grey': '#999999',
    'mine-shaft': '#212121',
    black: '#000',
    'black-10': 'rgba(0,0,0,0.1)',
    'black-20': 'rgba(0,0,0,0.2)',
    'black-30': 'rgba(0,0,0,0.3)',
    'black-40': 'rgba(0,0,0,0.4)',
    'black-50': 'rgba(0,0,0,0.5)',

    'sea-pink': '#E899A2',
    roman: '#BB4333',

    'aqua-deep': '#004C42',
    'spring-green': '#C0BEA5',

    partner: '#1A3D69',
    'partner-alt': '#CAD7DC',
};

module.exports = colors;
